export const singleStudent = () => {
  (function(window, document, $) {
    const fixedViewportBottom = document.querySelector('#globalFixedViewportBottomButton') as HTMLElement | null;
    const visibleBorder = document.querySelectorAll('.js-visibleFixedViewport');
    if (!fixedViewportBottom || !visibleBorder) return;


    const options = {
      root: null,
      rootMargin: '-10px',
      threshold: 0
    };

    function toggleUI(entries) {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          fixedViewportBottom?.classList.remove('u-op--hide');
          fixedViewportBottom?.classList.add('u-op--visible');
        } else {
          fixedViewportBottom?.classList.remove('u-op--visible');
          fixedViewportBottom?.classList.add('u-op--hide');
        }
      });
    }

    const observer = new IntersectionObserver(toggleUI, options);
    visibleBorder.forEach((elm: Element) => {
      elm.style.height = document.body.offsetHeight + 'px';
      observer.observe(elm);
    });
  })(window, document, jQuery);
};
